module.exports = __webpack_public_path__ + "img/Big_Icon_Shield.8b0f2cdb.svg";